import { useState } from "react";
import { Button, Card, CardBody, CardHeader, Modal } from "reactstrap";

const DataViewModal = ({ isOpenData, toggleData, dataView }) => {
    const [prettifyData, setPrettifyData] = useState('')
    const prettify = () => {
        if (dataView && typeof dataView === 'string') {

            setPrettifyData(JSON.stringify(JSON.parse(dataView.replace(/\\"/g, '"').replace(/\\\\/g, '\\').replace(/\\\\/g, ' ')), null, 2));
        }
    }

    return (
        <Modal className={`modal-action modal-lg`} isOpen={isOpenData} toggle={toggleData}>
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Data
                    <Button className='btn float-end' close onClick={toggleData} />
                </CardHeader>
                <CardBody className="text-left">
                    {!!prettifyData ? <pre style={{ width: '100%' }}>{prettifyData}</pre> : <div style={{ width: '100%', overflowX: 'auto', whiteSpace: 'nowrap' }}>{dataView}</div>}
                    <div className='d-flex justify-content-end mt-3'>
                        <Button className='btn-sm mr-2' color='primary' onClick={prettify}>Prettify</Button>
                        <Button className='btn-sm' color='outline-primary' onClick={() => { toggleData(); setPrettifyData(dataView) }}>Cancel</Button>
                    </div>
                </CardBody>
            </Card>
        </Modal>)
}

export default DataViewModal;